/**
 * ValidationSection - Collapsible section component for validation
 */

import { ChevronDown, ChevronRight } from 'lucide-react';
import type React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export interface ValidationSectionProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export function ValidationSection({
  title,
  description,
  icon,
  isExpanded,
  onToggle,
  children,
  actions,
}: ValidationSectionProps) {
  return (
    <Card>
      <CardHeader className="cursor-pointer hover:bg-muted/50 transition-colors" onClick={onToggle}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {isExpanded ? (
              <ChevronDown className="h-5 w-5 text-muted-foreground" />
            ) : (
              <ChevronRight className="h-5 w-5 text-muted-foreground" />
            )}
            {icon}
            <div>
              <CardTitle className="text-lg">{title}</CardTitle>
              {description && <p className="text-sm text-muted-foreground mt-0.5">{description}</p>}
            </div>
          </div>
          {actions && <div onClick={(e) => e.stopPropagation()}>{actions}</div>}
        </div>
      </CardHeader>
      {isExpanded && <CardContent className="pt-0">{children}</CardContent>}
    </Card>
  );
}
